import { render, staticRenderFns } from "./NavNew.vue?vue&type=template&id=327ec19a&scoped=true&"
import script from "./NavNew.vue?vue&type=script&lang=js&"
export * from "./NavNew.vue?vue&type=script&lang=js&"
import style0 from "./NavNew.vue?vue&type=style&index=0&id=327ec19a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327ec19a",
  null
  
)

export default component.exports